import { SeriousAboutTalent } from "@/ui/SeriousAboutTalent";
import { useLocale } from "@/hooks/useLocale";
import Image from "@/ui/Image";
import { Col } from "react-bootstrap";
import { stripTags } from "@/functions/stripTags";
import YoutubeVideoModal from "@/ui/YoutubeVideoModal";
import { getGlobal } from "@/functions/getGlobal";
import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import React from "react";

export const AboutPageContentSection = ({ className }) => {
  const global = getGlobal();
  const locale = useLocale();

  return (
    <SeriousAboutTalent
      className={className}
      tag={`page.about.content.tag.${locale}`}
      title={`page.about.content.title.${locale}`}
      text={`page.about.content.text.${locale}`}
      details={`page.about.content.details.${locale}`}
    >
      <Col xs={12} lg={6}>
        {/* START: CMS Tools editable fix */}
        <SourceFlowText
          global={global}
          path={`page.about.content.video.${locale}`}
          type="text"
          className="visually-hidden"
        />
        {/* END: CMS Tools editable fix */}
        <YoutubeVideoModal video_embed_url={stripTags(global[`page.about.content.video.${locale}`]).trim()}>
          <div className="ratio ratio-4x3 mt-4">
            <Image
              img={{
                path: "page.about.content.image",
                src: "/assets/about_us/content/1.jpg",
              }}
              size="622x"
              alt=""
              style={{ objectFit: "cover", objectPosition: "center right" }}
            />
          </div>
        </YoutubeVideoModal>
      </Col>
    </SeriousAboutTalent>
  );
};
